// removed by extract-text-webpack-plugin
module.exports = {"table":"header__table__2tOMR","thead":"header__thead__1_xu5","tr":"header__tr__3Vnxw","th":"header__th__1Lznr","resizeColumn":"header__resizeColumn__1Ol4z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataTable/Header/header.css
// module id = 1637
// module chunks = 0